module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whs"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "whs-loading"
  }, [_c('div', {
    staticClass: "whs-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.loading) ? _c('div', {
    staticClass: "whs-error"
  }, [_c('p', {
    staticClass: "whs-error-title"
  }, [_vm._v("Could not load webhooks")]), _vm._v(" "), _c('p', {
    staticClass: "whs-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "whs-btn whs-btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchAll
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.loadError) ? [_c('div', {
    staticClass: "whs-page-head"
  }, [_vm._m(0), _vm._v(" "), (!_vm.showForm) ? _c('button', {
    staticClass: "whs-btn whs-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openForm
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-right": "6px",
      "vertical-align": "-1px"
    },
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n        Add webhook\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.showForm) ? _c('div', {
    staticClass: "whs-card whs-form-card"
  }, [_c('h3', {
    staticClass: "whs-card-title"
  }, [_vm._v("New webhook")]), _vm._v(" "), (_vm.formError) ? _c('div', {
    staticClass: "whs-alert-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.formError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "whs-field"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formUrl),
      expression: "formUrl"
    }],
    staticClass: "whs-input",
    attrs: {
      "type": "url",
      "placeholder": "https://hooks.example.com/sentrykit",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.formUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "whs-field"
  }, [_c('label', {
    staticClass: "whs-field-label"
  }, [_vm._v("ALERT TYPES")]), _vm._v(" "), _c('label', {
    staticClass: "whs-check-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formAllTypes),
      expression: "formAllTypes"
    }],
    staticClass: "whs-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formAllTypes) ? _vm._i(_vm.formAllTypes, null) > -1 : (_vm.formAllTypes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formAllTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formAllTypes = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.formAllTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formAllTypes = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (!_vm.formAllTypes) ? _c('div', {
    staticClass: "whs-type-grid"
  }, _vm._l((_vm.alertTypes), function(t) {
    return _c('label', {
      key: t,
      staticClass: "whs-type-chip-label",
      class: {
        'active': _vm.formSelectedTypes.indexOf(t) > -1
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formSelectedTypes),
        expression: "formSelectedTypes"
      }],
      staticClass: "whs-type-hidden-cb",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": t,
        "checked": Array.isArray(_vm.formSelectedTypes) ? _vm._i(_vm.formSelectedTypes, t) > -1 : (_vm.formSelectedTypes)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.formSelectedTypes,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = t,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.formSelectedTypes = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.formSelectedTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.formSelectedTypes = $$c
          }
        }
      }
    }), _vm._v("\n            " + _vm._s(_vm.labelFor(t)) + "\n          ")])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.formAllTypes && _vm.formSelectedTypes.length === 0) ? _c('p', {
    staticClass: "whs-field-hint whs-field-hint-warn"
  }, [_vm._v("Select at least one alert type, or enable \"All alert types\".")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "whs-form-actions"
  }, [_c('button', {
    staticClass: "whs-btn whs-btn-outline",
    attrs: {
      "type": "button",
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.closeForm
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "whs-btn whs-btn-primary",
    class: {
      'whs-btn-loading': _vm.submitting
    },
    attrs: {
      "type": "button",
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.createWebhook
    }
  }, [_vm._v("\n          " + _vm._s(_vm.submitting ? 'Creating…' : 'Create webhook') + "\n        ")])])]) : _vm._e(), _vm._v(" "), (!_vm.webhooks.length && !_vm.showForm) ? _c('div', {
    staticClass: "whs-empty"
  }, [_c('svg', {
    staticClass: "whs-empty-icon",
    attrs: {
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "6",
      "y": "10",
      "width": "36",
      "height": "28",
      "rx": "3",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6 18h36",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14 28h8M14 33h16",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "38",
      "cy": "38",
      "r": "8",
      "fill": "var(--bg-light)",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35 38h6M38 35v6",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "whs-empty-title"
  }, [_vm._v("No webhooks yet")]), _vm._v(" "), _c('p', {
    staticClass: "whs-empty-sub"
  }, [_vm._v("Add an endpoint and we'll deliver alert notifications the moment they fire.")]), _vm._v(" "), _c('button', {
    staticClass: "whs-btn whs-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openForm
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-right": "5px",
      "vertical-align": "-1px"
    },
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n        Add webhook\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.webhooks.length) ? _c('div', {
    staticClass: "whs-list"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.webhooks), function(wh) {
    return _c('div', {
      key: wh.id,
      staticClass: "whs-row-wrap"
    }, [(!wh.enabled && wh.disabled_reason === 'consecutive_failures') ? _c('div', {
      staticClass: "whs-banner-error",
      attrs: {
        "role": "alert"
      }
    }, [_c('svg', {
      staticStyle: {
        "flex-shrink": "0"
      },
      attrs: {
        "width": "15",
        "height": "15",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
        "clip-rule": "evenodd"
      }
    })]), _vm._v(" "), _c('span', [_vm._v("Auto-disabled after repeated delivery failures. Fix your endpoint, then\n            "), _c('button', {
      staticClass: "whs-banner-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.reenableWebhook(wh)
        }
      }
    }, [_vm._v("re-enable it")]), _vm._v(".\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "whs-row",
      class: {
        'whs-row-off': !wh.enabled,
        'whs-row-expanded': _vm.expandedId === wh.id
      }
    }, [_c('div', {
      staticClass: "whs-col-url"
    }, [_c('span', {
      staticClass: "whs-url-text",
      attrs: {
        "title": wh.url
      }
    }, [_vm._v(_vm._s(_vm.truncateUrl(wh.url)))])]), _vm._v(" "), _c('div', {
      staticClass: "whs-col-types"
    }, [(!wh.subscribed_alert_types.length) ? _c('span', {
      staticClass: "whs-chip whs-chip-all"
    }, [_vm._v("All types")]) : [_vm._l((wh.subscribed_alert_types.slice(0, 2)), function(t) {
      return _c('span', {
        key: t,
        staticClass: "whs-chip"
      }, [_vm._v(_vm._s(_vm.labelFor(t)))])
    }), _vm._v(" "), (wh.subscribed_alert_types.length > 2) ? _c('span', {
      staticClass: "whs-chip whs-chip-more"
    }, [_vm._v("+" + _vm._s(wh.subscribed_alert_types.length - 2))]) : _vm._e()]], 2), _vm._v(" "), _c('div', {
      staticClass: "whs-col-health"
    }, [_c('span', {
      staticClass: "whs-health",
      class: _vm.healthClass(wh)
    }, [_vm._v(_vm._s(_vm.healthLabel(wh)))])]), _vm._v(" "), _c('div', {
      staticClass: "whs-col-toggle"
    }, [_c('button', {
      staticClass: "whs-toggle",
      class: {
        'whs-toggle-on': wh.enabled
      },
      attrs: {
        "type": "button",
        "disabled": _vm.togglingIds.indexOf(wh.id) > -1,
        "title": wh.enabled ? 'Disable webhook' : 'Enable webhook',
        "aria-pressed": wh.enabled
      },
      on: {
        "click": function($event) {
          return _vm.toggleEnabled(wh)
        }
      }
    }, [_c('span', {
      staticClass: "whs-toggle-knob"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "whs-col-actions"
    }, [_c('button', {
      staticClass: "whs-icon-btn",
      attrs: {
        "type": "button",
        "title": _vm.expandedId === wh.id ? 'Collapse' : 'Expand details'
      },
      on: {
        "click": function($event) {
          return _vm.toggleExpand(wh.id)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [(_vm.expandedId === wh.id) ? _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
      }
    }) : _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "whs-icon-btn whs-icon-btn-danger",
      attrs: {
        "type": "button",
        "title": "Delete webhook"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDelete(wh.id)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "15",
        "height": "15",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zm-1 5a1 1 0 012 0v6a1 1 0 11-2 0V7zm4 0a1 1 0 012 0v6a1 1 0 11-2 0V7z"
      }
    })])])])]), _vm._v(" "), (_vm.expandedId === wh.id) ? _c('div', {
      staticClass: "whs-detail"
    }, [_c('div', {
      staticClass: "whs-detail-actions"
    }, [_c('button', {
      staticClass: "whs-btn whs-btn-outline whs-btn-sm",
      class: {
        'whs-btn-loading': _vm.testPending[wh.id]
      },
      attrs: {
        "type": "button",
        "disabled": _vm.testPending[wh.id]
      },
      on: {
        "click": function($event) {
          return _vm.sendTest(wh.id)
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "margin-right": "5px",
        "vertical-align": "-1px"
      },
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
        "clip-rule": "evenodd"
      }
    })]), _vm._v("\n              " + _vm._s(_vm.testPending[wh.id] ? 'Sending…' : 'Send test event') + "\n            ")]), _vm._v(" "), _c('button', {
      staticClass: "whs-btn whs-btn-outline whs-btn-sm",
      class: {
        'whs-btn-loading': _vm.rotatePending[wh.id]
      },
      attrs: {
        "type": "button",
        "disabled": _vm.rotatePending[wh.id]
      },
      on: {
        "click": function($event) {
          return _vm.rotateSecret(wh.id)
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "margin-right": "5px",
        "vertical-align": "-1px"
      },
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
        "clip-rule": "evenodd"
      }
    })]), _vm._v("\n              " + _vm._s(_vm.rotatePending[wh.id] ? 'Rotating…' : 'Rotate secret') + "\n            ")]), _vm._v(" "), (_vm.testResults[wh.id]) ? _c('span', {
      staticClass: "whs-test-result",
      class: _vm.testResults[wh.id].ok ? 'whs-result-ok' : 'whs-result-fail'
    }, [(_vm.testResults[wh.id].ok) ? _c('svg', {
      attrs: {
        "width": "14",
        "height": "14",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        "clip-rule": "evenodd"
      }
    })]) : _c('svg', {
      attrs: {
        "width": "14",
        "height": "14",
        "viewBox": "0 0 20 20",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
        "clip-rule": "evenodd"
      }
    })]), _vm._v("\n              " + _vm._s(_vm.testResults[wh.id].label) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "whs-delivery-wrap"
    }, [_c('p', {
      staticClass: "whs-delivery-label"
    }, [_vm._v("Recent deliveries")]), _vm._v(" "), (_vm.deliveriesLoading[wh.id]) ? _c('div', {
      staticClass: "whs-delivery-loading"
    }, [_c('div', {
      staticClass: "whs-spinner whs-spinner-sm"
    }), _vm._v(" Loading…\n            ")]) : (_vm.deliveries[wh.id] && !_vm.deliveries[wh.id].length) ? _c('div', {
      staticClass: "whs-delivery-empty"
    }, [_vm._v("\n              No deliveries recorded yet. Use \"Send test event\" to verify your endpoint works.\n            ")]) : (_vm.deliveries[wh.id] && _vm.deliveries[wh.id].length) ? _c('table', {
      staticClass: "whs-delivery-table"
    }, [_vm._m(5, true), _vm._v(" "), _c('tbody', _vm._l((_vm.deliveries[wh.id]), function(d) {
      return _c('tr', {
        key: d.id
      }, [_c('td', [_c('span', {
        staticClass: "whs-delivery-status",
        class: d.success ? 'whs-d-ok' : 'whs-d-fail'
      }, [(d.success) ? _c('svg', {
        attrs: {
          "width": "12",
          "height": "12",
          "viewBox": "0 0 20 20",
          "fill": "currentColor"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "d": "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
          "clip-rule": "evenodd"
        }
      })]) : _c('svg', {
        attrs: {
          "width": "12",
          "height": "12",
          "viewBox": "0 0 20 20",
          "fill": "currentColor"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "d": "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
          "clip-rule": "evenodd"
        }
      })]), _vm._v("\n                      " + _vm._s(d.response_code || (d.success ? '200' : 'Err')) + "\n                    ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.labelFor(d.event_type)))]), _vm._v(" "), _c('td', [_vm._v("#" + _vm._s(d.attempt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(d.latency_ms != null ? d.latency_ms + 'ms' : '—'))]), _vm._v(" "), _c('td', {
        staticClass: "whs-delivery-time"
      }, [_vm._v(_vm._s(_vm.formatTime(d.attempted_at)))])])
    }), 0)]) : _vm._e()])]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "whs-info-card"
  }, [_c('div', {
    staticClass: "whs-info-card-head"
  }, [_c('svg', {
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n        Verifying signatures in your receiver\n      ")]), _vm._v(" "), _vm._m(6)])] : _vm._e(), _vm._v(" "), (_vm.secretModal.show) ? _c('div', {
    staticClass: "whs-overlay",
    attrs: {
      "role": "dialog",
      "aria-modal": "true"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeSecretModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "whs-modal"
  }, [_c('div', {
    staticClass: "whs-modal-icon-wrap whs-modal-icon-amber"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2",
      "ry": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "whs-modal-title"
  }, [_vm._v(_vm._s(_vm.secretModal.isRotation ? 'New signing secret' : 'Webhook created — save your secret'))]), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.secretModal.isRotation) ? _c('p', {
    staticClass: "whs-modal-note"
  }, [_vm._v("\n        Your "), _c('strong', [_vm._v("previous secret stays valid for 24 hours")]), _vm._v(" so you can update your receiver without downtime.\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "whs-secret-box"
  }, [_c('code', {
    staticClass: "whs-secret-code"
  }, [_vm._v(_vm._s(_vm.secretModal.secret))]), _vm._v(" "), _c('button', {
    staticClass: "whs-copy-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.secretModal.secret, 'secret')
      }
    }
  }, [(_vm.copied !== 'secret') ? _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
    }
  }), _c('path', {
    attrs: {
      "d": "M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
    }
  })]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.copied === 'secret' ? '✓ Copied!' : 'Copy') + "\n        ")])]), _vm._v(" "), _c('button', {
    staticClass: "whs-btn whs-btn-primary whs-modal-done-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeSecretModal
    }
  }, [_vm._v("Done, I've copied it")])])]) : _vm._e(), _vm._v(" "), (_vm.deleteConfirmId != null) ? _c('div', {
    staticClass: "whs-overlay",
    attrs: {
      "role": "dialog",
      "aria-modal": "true"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.deleteConfirmId = null
      }
    }
  }, [_c('div', {
    staticClass: "whs-modal whs-modal-sm"
  }, [_c('h3', {
    staticClass: "whs-modal-title"
  }, [_vm._v("Delete webhook?")]), _vm._v(" "), _c('p', {
    staticClass: "whs-modal-body"
  }, [_vm._v("This permanently removes the webhook and stops all future deliveries. This cannot be undone.")]), _vm._v(" "), _c('div', {
    staticClass: "whs-modal-btns"
  }, [_c('button', {
    staticClass: "whs-btn whs-btn-outline",
    attrs: {
      "type": "button",
      "disabled": _vm.deleting
    },
    on: {
      "click": function($event) {
        _vm.deleteConfirmId = null
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "whs-btn whs-btn-danger",
    class: {
      'whs-btn-loading': _vm.deleting
    },
    attrs: {
      "type": "button",
      "disabled": _vm.deleting
    },
    on: {
      "click": function($event) {
        return _vm.deleteWebhook(_vm.deleteConfirmId)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.deleting ? 'Deleting…' : 'Delete webhook') + "\n        ")])])])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whs-page-head-text"
  }, [_c('h1', {
    staticClass: "whs-title"
  }, [_vm._v("Webhooks")]), _vm._v(" "), _c('p', {
    staticClass: "whs-subtitle"
  }, [_vm._v("Receive real-time alert notifications at your own URL. Works with n8n, Make, Zapier, webhook.site, or your own server.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "whs-field-label"
  }, [_vm._v("ENDPOINT URL "), _c('span', {
    staticClass: "whs-required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "whs-field-hint"
  }, [_vm._v("Must start with "), _c('code', {
    staticClass: "whs-code"
  }, [_vm._v("https://")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "whs-check-label"
  }, [_c('strong', [_vm._v("All alert types")]), _vm._v(" — receive every alert as it fires")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whs-list-head"
  }, [_c('div', {
    staticClass: "whs-col-url"
  }, [_vm._v("Endpoint")]), _vm._v(" "), _c('div', {
    staticClass: "whs-col-types"
  }, [_vm._v("Alert types")]), _vm._v(" "), _c('div', {
    staticClass: "whs-col-health"
  }, [_vm._v("Health")]), _vm._v(" "), _c('div', {
    staticClass: "whs-col-toggle"
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('div', {
    staticClass: "whs-col-actions"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Event type")]), _vm._v(" "), _c('th', [_vm._v("Attempt")]), _vm._v(" "), _c('th', [_vm._v("Latency")]), _vm._v(" "), _c('th', [_vm._v("Time")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "whs-info-card-text"
  }, [_vm._v("Each delivery includes "), _c('code', {
    staticClass: "whs-code"
  }, [_vm._v("X-SentryKit-Signature: t=<unix>,v1=<hmac>")]), _vm._v(". Verify with "), _c('code', {
    staticClass: "whs-code"
  }, [_vm._v("HMAC-SHA256(secret, \"t.raw_body\")")]), _vm._v(" and reject timestamps older than 5 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "whs-modal-body"
  }, [_c('strong', [_vm._v("Copy this now — it won't be shown again.")]), _vm._v(" Paste it into your receiver to verify our signature.\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bd1f5cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/WebhooksSettings.vue
// module id = 739
// module chunks = 2